/**
 * Mutation hook for ending a promotion (setting valid_upto to today).
 *
 * Calls the end_promotion endpoint which deactivates a Pricing Rule
 * without deleting it. Used by the "End now" action on promotion pills.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { frappeMethod } from "@/lib/erp/utils";
import { pricingRuleQueryKeys } from "./pricingRuleQueryKeys";

// ── Types ────────────────────────────────────────────────────

interface EndPromotionResponse {
  status: string;
  name: string;
}

// ── Hook ─────────────────────────────────────────────────────

export function useEndPromotion(itemCode: string) {
  const queryClient = useQueryClient();

  return useMutation<EndPromotionResponse, Error, string>({
    mutationFn: (pricingRuleName: string) =>
      frappeMethod<EndPromotionResponse>(
        "zaviago_backend.api.pricing_promotion_actions.end_promotion",
        { pricing_rule_name: pricingRuleName }
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["pricing-summary", itemCode],
      });
      queryClient.invalidateQueries({
        queryKey: ["itemPricingTable", itemCode],
      });
      queryClient.invalidateQueries({
        queryKey: pricingRuleQueryKeys.all(),
      });
    },
  });
}
